import NgqlUI from 'gql/ninegqlUI'
import store from 'store'
import { store as reduxStore } from 'index'

import appTypeConfigFunc from 'apptype-config'

const ngqlUIInfo = NgqlUI

const envParam = {}

export function getRouterType() {
  return 'browser' // hash, browser
}

export function setEnvParam(key, value) {
  envParam[key] = value
  store.set(`envParem.${key}`, value)

  if (key === 'appType') {
    reduxStore.dispatch({
      type: 'menu/RELOAD',
    })
  }
}

export function getEnvParam(key) {
  // UI 테스트용..~!!!!
  // if (key === 'appType') {
  //   return 'REWORK-ENTERPRISE-PORTAL'
  // }

  if (envParam[key] == null) {
    return store.get(`envParem.${key}`)
  }
  return envParam[key]
}

export function removeEnvParam(key) {
  store.remove(`envParem.${key}`);
  delete envParam[key];
}

export function getConfig(key) {
  const { config } = appTypeConfigFunc()
  if (key == null) {
    return config
  }

  return config[key]
}

// export function setNgqlUIInfo(prop) {
//   ngqlUIInfo = prop;
// }
// setNgqlUIInfo(NgqlUI);

export function getDefaultArrayIFace() {
  const iface = {
    getNodes: (resData) => {
      let ret = null
      if (resData != null && resData.edges != null) {
        ret = resData.edges
      } else if (Array.isArray(resData) === true) {
        ret = resData.map((item) => {
          return {
            node: item,
          }
        })
      } else {
        ret = [{ node: resData }]
      }
      return ret
    },
    getMoreCursor: (resData, lastItemData) => {
      if (resData != null && resData.pageInfo != null) {
        return resData.pageInfo.endCursor
      }
      if (lastItemData != null) {
        return lastItemData.cursor
      }
      return null
    },
    getTotalCount: (resData) => {
      let ret = 1
      if (resData != null && resData.totalCount != null) {
        ret = resData.totalCount
      } else if (Array.isArray(resData) === true) {
        ret = resData.length
      }
      return ret
    },
    getArgument: (vars, key, defaultVal) => {
      if (vars != null) {
        return vars[key]
      }
      return vars[key] != null ? vars[key] : defaultVal
    },
    setArgument: (vars, key, val) => {
      vars[key] = val
    },
  }

  return iface
}

// export function getDefaultArrayIFace() {
//   return null;
// }

export function getNgqlUIInfo() {
  return ngqlUIInfo
}

export function getNgqlConfig() {
  return {
    tableClickRange: 8,
  }
}
